module.exports = __webpack_public_path__ + "static/media/icons_Bilan Rachis complet.1cbc562c.svg";